import { Link } from "react-router-dom";
import { COMPANY } from "../lib/company";

export default function Footer() {
  return (
    <footer className="border-t border-black/10 mt-24" data-testid="site-footer">
      <div className="max-w-screen-xl mx-auto px-8 py-12 grid md:grid-cols-12 gap-8 text-sm">
        <div className="md:col-span-3">
          <div className="font-mono tracking-widest uppercase text-xs">Hop · Diagnostic</div>
          <p className="mt-4 text-foreground/65 leading-relaxed">
            Диагностический инструмент {COMPANY.brand} — оценка готовности стартапа
            к&nbsp;трём типам интереса.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="label-mono mb-3">ОПЕРАТОР</div>
          <div className="text-foreground/80 leading-relaxed">
            {COMPANY.shortName}
            <br />
            ИНН {COMPANY.inn}
            <br />
            ОГРН {COMPANY.ogrn}
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="label-mono mb-3">КОНТАКТ</div>
          <div className="text-foreground/80 leading-relaxed">
            <span className="block">{COMPANY.address}</span>
            <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} className="hop-link mt-2 inline-block">
              {COMPANY.phone}
            </a>
            <br />
            <a href={`mailto:${COMPANY.email}`} className="hop-link">{COMPANY.email}</a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="label-mono mb-3">ПРАВОВАЯ ИНФОРМАЦИЯ</div>
          <div className="space-y-1">
            <Link to="/privacy" className="hop-link block" data-testid="footer-privacy-link">Политика обработки персональных данных</Link>
            <Link to="/consent-text" className="hop-link block" data-testid="footer-consent-link">Согласие на обработку персональных данных</Link>
            <Link to="/terms" className="hop-link block" data-testid="footer-terms-link">Условия использования</Link>
            <a href={COMPANY.website} target="_blank" rel="noreferrer" className="hop-link block">{COMPANY.brand}</a>
          </div>
        </div>

        <div className="md:col-span-12 border-t border-black/10 pt-6 mt-2 text-foreground/50 text-xs flex flex-wrap items-center justify-between gap-4">
          <span>© 2026 {COMPANY.shortName}</span>
          <span className="mono">Diagnostic v0.1 · 152-ФЗ</span>
        </div>
      </div>
    </footer>
  );
}
